<template>
  <collapsible-section class='_pt0 _pb0' sectionName="Benefits" @benefitsToggled='toggleWithoutRerender'>
    <template #headerText>
      <p class='color-leaf'>Benefits Summary</p>
    </template>
    <template #headerActions>
      <a href="javascript:void(0);" @click="print" class="btn white --sm">Print</a>
    </template>
    <template #collapsibleSection>
      <async-loader v-if="memberDetailsLoading"/>
      <div v-else container>
        <MemberBenefitTiers :memberCK="memberCK" :dos="dos" :authToken="authToken" :benefitCategoryId="activeEligibilityBeneCategoryId" :memberName="memberFullName" />
      </div>
    </template>
  </collapsible-section>
</template>

<script>
  import CollapsibleSection from '@sections/CollapsibleSection'
  import MemberBenefitTiers from '@organisms/MemberBenefitTiers'
  import memberManagement from '@mixins/memberManagement'
  import benefitsSummaryAndEligibility from '@mixins/benefitsSummaryAndEligibility'

  export default {
    name: 'MemberBenefitTiersContainer',
    mixins: [ memberManagement, benefitsSummaryAndEligibility ],
    components: {
      MemberBenefitTiers,
      CollapsibleSection
    },
    props: {
      memberCK: String,
      dos: String,
      authToken: String
    },
    computed: {
      activeEligibilityBeneCategoryId () {
        return this.activeBenefitCategory.id
      },
      memberFullName () {
        return this.memberDetails.member.firstName + ' ' + this.memberDetails.member.lastName
      }
    },
    methods: {
      print: () => window.print(),
      toggleWithoutRerender(collapsed) {
        if (!collapsed) {
          // window.location.reload(true);
          document.getElementById('benefits-display-app-container').parentElement.parentElement.parentElement.style.display = ''
          document.getElementById('benefits-display-app-container').parentElement.parentElement.parentElement.className = 'drawer'
        } else {
          document.getElementById('benefits-display-app-container').parentElement.parentElement.parentElement.style.display = 'none'
        }
      }
    }
    /* updated() {
      const self = this;
      //self.updateBenefits(self);
      this.$nextTick(function () {
        // Code that will run only after the
        // entire view has been re-rendered
        //self.updateBenefits();
      })

    } */
  }
</script>
